import './router/componentHooks';
import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import '@/plugins';
import '@/styles/index.scss';
import vClickOutside from 'v-click-outside';
import VueScrollactive from 'vue-scrollactive';
import filters from '@/plugins/filters';
import ZoomOnHover from 'vue-zoom-on-hover';

Vue.config.productionTip = false;

Vue.use(ZoomOnHover);
Vue.use(vClickOutside);
Vue.use(VueScrollactive);
Vue.use(filters);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
